import { createContext, useContext } from "react";

import { NO_ENROLLMENT_FLAGS } from "../../utils/enrollmentFlagLevel";

import type { FC, ReactNode } from "react";
import type { EnrollmentFlagState } from "../../utils/enrollmentFlagLevel";

/**
 * What decides the flags on a plan's enrolled cells. The cells are rendered several
 * components below the group, in renderers that do not receive it.
 */
const EnrollmentFlagContext =
  createContext<EnrollmentFlagState>(NO_ENROLLMENT_FLAGS);

export interface EnrollmentFlagProviderProps {
  state: EnrollmentFlagState;
  children: ReactNode;
}

export const EnrollmentFlagProvider: FC<EnrollmentFlagProviderProps> = ({
  state,
  children,
}) => (
  <EnrollmentFlagContext.Provider value={state}>
    {children}
  </EnrollmentFlagContext.Provider>
);

export const useEnrollmentFlagState = (): EnrollmentFlagState =>
  useContext(EnrollmentFlagContext);
